export default "__VITE_ASSET__c58d034f__"